<template>
  <component
    :is="PaymentFormAdornment"
    v-if="PaymentFormAdornment"
    v-bind="props"
  >
    <slot />
  </component>
  <slot v-else />
</template>

<script lang="ts" setup>
import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { usePaymentFormVersion } from '../../../form-common/composables/usePaymentFormVersion'

import type { PaymentFormAdornmentProps } from './PaymentFormAdornment.type'
import AffirmPaymentFormAdornment from './components/AffirmPaymentFormAdornment.vue'
import KlarnaPaymentFormAdornment from './components/KlarnaPaymentFormAdornment.vue'
import LegacyPaymentFormAdornment from './components/LegacyPaymentFormAdornment.vue'
import OneyPaymentFormAdornment from './components/OneyPaymentFormAdornment.vue'
import PaypalPaymentFormAdornment from './components/PaypalPaymentFormAdornment.vue'
import ScalapayPaymentFormAdornment from './components/ScalapayPaymentFormAdornment.vue'
import SquarePaymentFormAdornment from './components/SquarePaymentFormAdornment.vue'

const props = defineProps<PaymentFormAdornmentProps>()

// Adornments use advertising library.
// If the advertising is disabled, we should keep the legacy text only adornment
const isAdvertisingEnabled = useRuntimeConfig().public.payment.KILL_ADVERTISING

const formVersion = usePaymentFormVersion()
const PaymentFormAdornment = computed(() => {
  if (
    formVersion === 'v1' ||
    isAdvertisingEnabled ||
    props.paymentMethod?.config?.disablePaymentFormAdvertising
  ) {
    return LegacyPaymentFormAdornment
  }

  switch (props.paymentMethod?.bmCode) {
    case 'affirm':
      return AffirmPaymentFormAdornment
    case 'afterpay':
    case 'clearpay':
      return SquarePaymentFormAdornment
    case 'klarna_pay_later':
    case 'klarna_slice_it':
      return KlarnaPaymentFormAdornment
    case 'oney3x':
    case 'oney4x':
    case 'oney6x':
    case 'oney10x':
    case 'oney12x':
      return OneyPaymentFormAdornment
    case 'paypal':
      return PaypalPaymentFormAdornment
    case 'scalapay':
    case 'scalapay3x':
      return ScalapayPaymentFormAdornment
    default:
      return LegacyPaymentFormAdornment
  }
})
</script>
